import {
  Outlet,
  useNavigate,
} from "react-router-dom";
import { useTheme } from "@mui/material";
import styles from './AppLayout.module.scss';
import MainNav from "./MainNav/MainNav";
import AppInfoView from "../../components/AppInfoView";
import { getLogoPath } from '../../utils/utils';

function AppLayout(props: any) {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <>
      <div className={`${styles.appLayout} ${styles.appLayout_isDesktop}`}>
        <div className={styles.appLayout__topbar}>
          <div className={styles.appLayout__topbarLogo}>
            <button className={styles.appLayout__logoButton} onClick={() => navigate("/beacons")}>
            <img src={getLogoPath()} alt="Skidattl Logo" />
            </button>
          </div>
          <MainNav />
        </div>

        <main role="main" className={styles.appLayout__main}>
          <Outlet />
        </main>
      </div>
      <AppInfoView />
    </>
  );
}

export { AppLayout };